import { INPUT_TYPES } from '../../config/constants';
import { Api } from '../../api/api-routes';
import { camelToSnakeCase } from '../../utils/common';
import { registrationTypes } from '../../config/types';


export const formSubmitMethods = {
    registerFeedback: ({ conf, type, registUrl, duuzraId, email }) => {
        const data = {
            username: email.value,
            password: conf.password,
            eventId: duuzraId,
            useDefaultPass: conf.useDefaultPass
        };

        for (let input of conf.result) {
            if (input.type === INPUT_TYPES.SELECT_USER_GROUP) {
                const groups = [];
                input.value.forEach(value => {
                    if (value.checked === 'true') {
                        value.groups.forEach(groupId => groups.push(groupId));
                    }
                });
                if ('groups' in data) {
                    groups.forEach(groupId => data['groups'].push(groupId))
                } else {
                    data['userGroups'] = groups;
                }
            }
            if (input.type === INPUT_TYPES.REGISTRATION && input.value) {
                const subType = typeof input.subType === 'string' ? input.subType : registrationTypes.find(el => el.id === input.subType).value;
                data[subType] = input.value;
            }
        }

        if ('groups' in data) {
            data['userGroups'] = data['groups'].filter((value, index, self) => self.indexOf(value) === index);
        }

        return data;
    },
    sendForm: (conf) => {
        return Api.sendForm(conf)
            .then(async (res) => {
                return Promise.resolve(res.id);
            })
            .then(id => {
                if (conf.filesForUpload.length) {
                    const formData = new FormData();
                    conf.filesForUpload.forEach(file => formData.append('files[]', file));
                    return Api.sendFiles({ resultId: id, data: formData });
                } else {
                    return Promise.resolve(id);
                }
            })
    }
};
